const data= {
  FacturasEmitidas: [
    {
      TicketMedio: 0,
      Rectificativas: 0,
      TotalImpuestos: 0,
      Importe: 0,
      Total: 0,
      Fecha: 'string'
    }
  ],
  DesgloseImpuestos: [
    {
      Tipo: 'string',
      Total: 0,
      Porcentaje: 0,
      Periodo: 'string'
    }
  ],
  blnError: false,
  codError: 'string',
  msgError: 'string'
}

export default data
